export default "__VITE_ASSET__BbCyPzUI__"